import { QueryParameterSchema } from './types';

export const agencyFilterQueryFilter: QueryParameterSchema<'agency'> = {
  getDefaultValue: () => [],
  getValue: ({ queryParameters }) => queryParameters.agency,

  fromUrlSearchParams: ({ urlSearchParams }) => ({
    agency: urlSearchParams.get('filter[agency]')?.split(',') || [],
  }),
  toUrlSearchParams: ({ value }) => ({ 'filter[agency]': value.join(',') }),
  toSearchQuery: ({ value }) => {
    if (value.length === 0) return {};
    return { 'filter[agency]': value };
  },
  getSummaryItems: ({ agencies, value }) => {
    return value.map((id) => {
      const agency = agencies.find((p) => p.id === id);
      if (!agency) {
        return {
          filterKey: 'agency',
          key: `agency_${id}`,
          label: `Loading...`,
          value: id,
        };
      }
      return {
        filterKey: 'agency',
        key: `agency_${id}_loading`,
        label: `${agency.name}`,
        value: id,
      };
    });
  },
  removeParam: ({ value, removedValue }) => {
    return { agency: value.filter((item) => item !== removedValue) };
  },
};
